import {
  PagePaths,
  PageType,
} from "@agp/shared.user-app/application/context/navigation/type";
import { INavigationProps } from "@agp/shared.user-app/application/context/navigation";

export const createUrl = (
  pageType: PageType,
  applicationId: string,
  props: INavigationProps,
  anchor?: string,
) => {
  const path = PagePaths[pageType];

  // 現在のURLのクエリパラメータを取得
  const currentParams = new URLSearchParams(window.location.search);

  // applicationIdを設定または上書き
  currentParams.set("applicationId", applicationId);

  // propsで指定されたパラメータを設定または上書き
  Object.entries(props).forEach(([key, value]) => {
    currentParams.set(key, value.toString());
  });

  const query = currentParams.toString();
  const queryPart = query ? `?${query}` : "";

  // アンカーリンクが指定されている場合、URLに追加
  const anchorPart = anchor ? `#${anchor}` : "";

  return path + queryPart + anchorPart;
};
